module.exports = __webpack_public_path__ + "img/Person Icon - charcoal.df368382.svg";